import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { TranslateService } from './translate.service';
import { Observable } from 'rxjs';

export const TitleTranslateResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  translate: TranslateService = inject(TranslateService)
): Observable<string> => {
  return translate.get(route.data?.titleTranslation);
};
